import { useState } from "react";
import { CommonInfo } from "../../CommonData/Config";
import './BookingActionButton.css';

type BookingActionButtonProps = {
    theme: string;
    icon: string;
    label: string;
    bgColor: string;
    onClick: () => void;
}
const BookingActionButton = ({
    theme,
  icon,
  label,
  bgColor,
  onClick,
}: BookingActionButtonProps) => {

    const [hovered, setHovered] = useState(false);
    console.log("theme", theme);
    
  return (
    <div
      className="action-btn"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ backgroundColor: bgColor }}
      onClick={onClick}
    >
      <img src={`${CommonInfo.folderName}${icon}`} className="action-icon" />
      {hovered && <span className={ theme === "dark" ? "action-text" : "action-text-light"}>{label}</span>}
    </div>
  );
};

export default BookingActionButton;
